/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords>): BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords(), model);
        BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords>): BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords.newInstance(<BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicProcessOrphanedConfigurationRecords.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
